import { Component, OnInit, AfterViewInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-trial-explainer-modal',
  templateUrl: './trial-explainer-modal.component.pug',
  styleUrls: ['./trial-explainer-modal.component.scss'],
  standalone: false
})
export class TrialExplainerModalComponent implements OnInit, AfterViewInit {

  constructor(private modalService: BsModalService) {
    }

  ngOnInit(): void {}

  ngAfterViewInit() {
    setTimeout(() => {this.updateLine();}, 6);
    window.addEventListener('resize', () => this.updateLine());
  }

  updateLine() {
    const startEl = document.getElementById("green_trial_tick");
    const endEl = document.getElementById("white_trial_tick");
    const line = document.getElementById("line");

    if (startEl && endEl && line) {
      const startRect = startEl.getBoundingClientRect();
      const endRect = endEl.getBoundingClientRect();

      const containerTop = document.querySelector(".signup-module-content")?.getBoundingClientRect().top || 0;

      // Calculate top position & height
      const topPosition = startRect.top - containerTop + 120;
      const height = endRect.bottom - startRect.bottom;

      // Apply styles
      line.style.top = `${topPosition}px`;
      line.style.height = `${height}px`;
    }
  }

  closeModal(){
    this.modalService.hide();
  }

}
